module.exports = __webpack_public_path__ + "static/p19-6a111a710ddbf6b51f681ab1282baf8c.jpg";